
export const FETCH_DOSSIER_REQUEST = 'FETCH_DOSSIER_REQUEST';
export const FETCH_DOSSIER_SUCCESS = 'FETCH_DOSSIER_SUCCESS';
export const FETCH_DOSSIER_FAILURE = 'FETCH_DOSSIER_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';